<template>
  <div class="withdrawDetail">
    <common-title titleName="提现明细" :isAPPShow="true"></common-title>
    <div :class="`withdrawDetail__scroll_box ${this.$root.miniprogram ? 'pt36' : 0}`">
      <div class="accountDetail__top"></div>
      <div class="account">
        <div class="account__info-item">
          <span class="label" @click="onViewWithdrawDetail">
            可提现(元)
          </span>
          <span class="num" @click="onViewWithdrawDetail">{{ formatMoney(accountInfo.withdrawAmount) }}</span>
          <span class="btn-subscribe" @click="onSubscribe">
            立即提现
          </span>
        </div>
        <div class="account__info-item">
          <span class="label">
            冻结中(元)
          </span>
          <span class="num" @click="viewTip">{{ formatMoney(accountInfo.freezeAmount) }}<img
                  src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/invitationCommission/invite_tip.png"
                  alt="" ></span>
        </div>
      </div>
      <div class="content">
        <div class="content_title">提现明细</div>
        <div class="content_list">
          <div :class="`list_header list-item ${this.$root.miniprogram ? 'mini' : ''}`">
            <span>金额</span>
            <span>收款账户</span>
            <span>提现时间</span>
            <span>状态</span>
          </div>
          <van-list v-model="loading" :finished="finished" :immediate-check="false" :offset="20" v-if="list.length"
            @load="getList">
            <ul class="list_body">
              <li class="list_body-item list-item" v-for="(item, keys) in list" :key="keys">
                <span>{{ formatMoney(item.amount) }}</span>
                <span>{{ item.alipayAccount }}</span>
                <span>{{ formatTime(item.applyTime) }}</span>
                <span @click="setErrorInfo(item.rejectReason)">{{ statusText[item.status] }}<img
                    v-if="item.status === 3"
                    src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/invitationCommission/invite_tip.png"
                    alt=""></span>
              </li>
            </ul>
          </van-list>
          <div class="empty" v-if="!list.length">
            <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/invitationCommission/empty.png" alt="">
            <span>暂无数据～</span>
          </div>
        </div>
      </div>
    </div>
    <van-overlay :show="!!errorInfo" @click="errorInfo = ''">
      <div class="wrapper" @click.stop>
        <div class="wrapper__title">
          <span></span>
          <span>提现失败说明</span>
          <img @click="errorInfo = ''"
            src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/invitationCommission/invite_close.png"
            alt="">
        </div>
        <div class="wrapper__content">{{ errorInfo }}</div>
      </div>
    </van-overlay>
    <van-overlay :show="showTip" @click="showTip = false">
      <div class="wrapper wrapper_tip" @click.stop>
        <div class="wrapper__title">
          <span></span>
          <span>提现说明</span>
          <img @click="showTip = false"
            src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/invitationCommission/invite_close.png"
            alt="">
        </div>
        <div class="wrapper__content">
          <div v-if="tipType === 1">您当前尚无可提现的奖金，快去邀请好友一起报名学习吧！多邀多得哦！</div>
          <div v-if="tipType === 2">1、您当前暂不符合提现要求，无法提现。您购买实付金额大于200元的课程并且购买课程满30天后，才能获取提现资格。在此期间退课将失去提现资格<br /></div>
          <div :style="{ marginTop: '1em' }" v-if="tipType === 2">2、您的好友购买课程满30天后，奖金才能提现。在此期间退课将扣除奖金</div>
          <div v-if="tipType === 3" :style="{textAlign: 'center',}">您与好友购课30天后即可提现哦</div>
        </div>
      </div>
    </van-overlay>
    <Share :basicInfo="basicInfo" :accountInfo="accountInfo"></Share>
  </div>
</template>
<script>
import { mapState } from 'vuex';
// eslint-disable-next-line import/no-cycle
import {
  reqUserAccount,
  reqAccountWithdrawList,
  reqInvitationInfo,
} from '@/api/invitationCommission';

import CommonTitle from '@/components/header/CommonTitle.vue';
import { formatMoney } from '@/utils/tools';
import Share from '../components/ShareInvitation/index.vue';

export default {
  components: {
    CommonTitle,
    Share,
  },
  data() {
    return {
      basicInfo: {},
      accountInfo: {},
      pageSize: 10,
      pageNum: 1,
      list: [],
      loading: false,
      finished: false, // 是否加载到最后
      statusText: {
        1: '申请中', 2: '已到账', 3: '提现失败',
      },
      errorInfo: '',
      showTip: false,
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },

  beforeRouteEnter(to, from, next) {
    const token = window.localStorage.getItem('accessToken');
    if (token) {
      next();
    } else {
      next((vm) => {
        vm.$root.openLogin('/invitation/withdrawDetail');
      });
    }
  },
  mounted() {
    document.title = '提现明细';
    this.$toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 0,
    });
    this.initData();
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) {
        document.title = '提现明细';
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0,
        });
        this.initData();
      }
    });
  },
  methods: {
    initData() {
      this.getInvitationInfo();
      this.pageNum = 1;
      this.list = [];
      this.finished = false;
      this.$nextTick(() => {
        this.initPage();
      });
    },
    formatMoney,
    formatTime(timeStr) {
      return timeStr?.split(' ')[0]?.replaceAll('-', '/') || '--';
    },
    initPage() {
      if (!this.userInfo?.id) return;
      this.getUserAccount();
      this.getList();
    },
    // 查看活动基本信息
    getInvitationInfo() {
      reqInvitationInfo().then((res) => {
        this.basicInfo = res;
      });
    },
    getList() {
      this.loading = true;
      const params = { pageSize: this.pageSize, pageNum: this.pageNum };
      reqAccountWithdrawList(params).then((res) => {
        const { data, pages, pageNum } = res;
        if (pageNum >= pages) {
          this.finished = true;
          this.list = [...this.list, ...data];
        } else {
          this.list = [...this.list, ...data];
          this.pageNum += 1;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    // 查看我的账户信息
    getUserAccount() {
      reqUserAccount().then((res) => {
        this.accountInfo = res;
      }).finally(() => {
        this.$toast.clear();
      });
    },
    viewTip() {
      this.showTip = true;
      this.tipType = 3;
    },
    onViewWithdrawDetail() {
      this.$router.push({
        path: '/invitation/withdrawDetail?back=back',
      });
    },
    onSubscribe() {
      const { withdrawAmount, freezeAmount } = this.accountInfo;
      if (!withdrawAmount) {
        this.showTip = true;
        this.tipType = freezeAmount ? 2 : 1;
      } else {
        this.$router.push({
          path: '/invitation/subscribe?back=back',
        });
      }
    },
    setErrorInfo(info) {
      if (!info) return;
      this.errorInfo = info;
    },
  },

  watch: {
    userInfo: {
      deep: true,
      handler(val) {
        if (!val?.id) {
          // 区分App和h5
          if (!(this.$root.$data.isApp || this.$root.$data.miniprogram)) {
            this.$routerr.push({
              path: '/registrationLogin',
              query: { redirect: '/invitation/withdrawDetail' },
            });
          }
        } else {
          this.initData();
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
.withdrawDetail {
  &__top {
    padding-top: 100px;
  }

  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #F7F8FC;

  &__scroll_box {
    width: 100%;
    height: calc(100% - 196px);
    padding-top: 136px;
    overflow-x: hidden;
    overflow-y: auto;

    &.pt36 {
      padding-top: 36px;
    }
  }

  .account {
    display: flex;
    flex-direction: column;
    width: 678px;
    height: 221px;
    margin: 0 auto;
    padding: 40px 29px;
    background: #FFF;
    border-radius: 14px;

    &__info-item {
      display: flex;
      align-items: center;

      .label {
        height: 36px;
        color: #333;
        font-weight: 400;
        font-size: 25px;
        font-style: normal;
        line-height: 36px;
        text-align: left;
      }

      .num {
        display: inline-block;
        height: 40px;
        margin-left: 29px;
        color: #333;
        font-weight: 600;
        font-size: 29px;
        font-style: normal;
        line-height: 40px;
        text-align: left;
        img {
          display: inline-block;
          width: 22px;
          height: 22px;
          margin-left: 7px;
        }
      }

      &:nth-child(2) {
        margin-top: 58px;
      }
    }

    .btn-subscribe {
      width: 116px;
      height: 42px;
      margin-left: auto;
      color: #FFF;
      font-weight: 500;
      font-size: 22px;
      font-style: normal;
      line-height: 44px;
      text-align: center;
      background: #FF7F41;
      border-radius: 22px;
    }
  }

  .content {
    padding-top: 43px;

    .content_list {
      width: 678px;
      margin: 0 auto;
      background: #FFF;
      border-radius: 14px;
    }

    .content_title {
      padding: 0 36px 22px;
      color: #111;
      font-weight: 500;
      font-size: 29px;
      font-style: normal;
      line-height: 40px;
      text-align: left;
    }

    .list_header {
      position: sticky;
      top: 116px;
      width: 678px;
      height: 91px;
      padding: 27px 29px 0;
      background-image: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/invitationCommission/detail_list.png');
      background-repeat: no-repeat;
      background-size: 678px 91px;

      &.mini {
        top: 0;
      }

      span {
        height: 36px;
        color: #999;
        font-weight: 400;
        font-size: 25px;
        font-style: normal;
        line-height: 36px;
        text-align: left;
      }
    }

    .list-item {
      display: flex;
      width: 678px;
      margin: 0 auto;

      span {
        &:nth-child(1) {
          width: 116px;
        }

        &:nth-child(2) {
          width: 205px;
        }

        &:nth-child(3) {
          width: 173px;
        }

        &:nth-child(4) {
          flex: 1;
        }
      }
    }

    // .list_main {
    //   max-height: calc(100vh - 1030px);
    //   overflow-x: hidden;
    //   overflow-y: scroll;
    // }

    .list_body {
      padding-bottom: 49px;

      .list_body-item {
        align-items: center;
        margin-top: 43px;
        padding: 0 29px;

        span {
          min-height: 36px;
          color: #333;
          font-weight: 500;
          font-size: 25px;
          font-style: normal;
          line-height: 30px;
          text-align: left;
          word-break: break-all;

          &:nth-child(2) {
            padding-right: 4px;
          }

          &:nth-child(4) img {
            position: relative;
            top: 2px;
            display: inline-block;
            width: 22px;
            height: 22px;
            margin-left: 2px;
          }
        }
      }
    }
  }

  ::v-deep .van-overlay {
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .wrapper {
    width: 634px;
    height: 259px;
    padding: 31px 33px 0;
    background: #FFF;
    border-radius: 36px;

    &__title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      color: #333;
      font-weight: 500;
      font-size: 29px;
      font-style: normal;
      line-height: 40px;
      text-align: center;

      span {
        font-weight: 500;
        &:nth-child(1) {
          width: 29px;
          height: 29px;
        }
      }

      & img {
        display: inline-block;
        width: 29px;
        height: 29px;
      }
    }

    &__content {
      height: 43px;
      margin-top: 62px;
      color: #333;
      font-weight: 400;
      font-size: 29px;
      font-style: normal;
      line-height: 43px;
      text-align: center;
    }

    &_tip {
      height: auto;
      padding: 31px 33px;
      padding-bottom: 72px;

      .wrapper__content {
        height: auto;
        margin-top: 43px;
        text-align: left;
      }
    }
  }

  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 100px;

    img {
      width: 308px;
      height: 219px;
      margin-bottom: 13px;
    }

    span {
      color: #999;
      font-weight: 400;
      font-size: 25px;
      font-style: normal;
      line-height: 36px;
      text-align: right;
    }
  }
}
</style>
